<script>

  export default {
    props: {
      type: {
        type: String,
        default: null,
      },
      collapse: {
        type: Boolean,
        default: false,
      },
      defaultFilters: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        tags: {},
        tagFilter: '',
        boundCollapse: false,
      }
    },
    async created() {
      // apply defaults
      if (this.defaultFilters && this.defaultFilters.length > 0){
        this.tagFilter = this.defaultFilters
      }

      this.boundCollapse = Boolean(this.collapse)
      this.boundCollapse = !this.boundCollapse

      // load options
      this.loadData()

      // dynamically create watcher AFTER init for future changes
      this.$watch('tagFilter', function () {
        this.$emit('filter', {
          tag: this.tagFilter,
        })
      })
    },
    methods: {
      async loadData () {
        this.tags = [
          {
            key : '',
            value : 'All Tags'
          },
          {
            key : 'returned',
            value : 'Returned'
          },
        ]
      },
    },
  }
</script>

<template>
  <div v-bind="$attrs" class="block-item">
    <div class="block-heading">
      <h3
        v-fabric-collapse.accordion-item-tags
        class="
          tw-flex tw-items-center
          tw-text-positive
          tw-leading-relaxed tw-font-medium tw-text-base">
        <a class="tw-no-underline" href="javascript:">Filter by Tag</a>
        <BaseChevronRotate
          transition-class="rotate-360-270"
          :toggle="!boundCollapse"
          :duration="500"
        />
      </h3>
    </div>
    <FabricCollapse
      id="accordion-item-tags"
      v-model="boundCollapse"
      hide-header
      :duration="500"
      :default-shown="boundCollapse">
      <div class="block-content">
        <FabricRadio 
          v-for="(tag, index) in tags"
          :key="`fab-tag-${index}`" 
          v-model="tagFilter"
          group-name="tagTypes"
          class="tw-mt-2 tw-mb-2"
          :value="tag.key">
          {{ tag.value }}
        </FabricRadio>
      </div>
    </FabricCollapse>
  </div>
</template>
